import Vue from 'vue';

class Utility {
    public user: any = null;
    public eventBus = new Vue();
    public popupTimer = 3000;
    public loginSuccessRoute = '/monthly-report/weekly-meetings';

    public initUser() {
        try {
            return (this.user = JSON.parse(localStorage.user));
        } catch (e) {
            return (this.user = null);
        }
    }

    public isLoggedIn(user?: any) {
        if ( !user ) {
            user = this.initUser();
        }

        return (
            typeof user === 'object' &&
            user !== null &&
            typeof user.pg_id !== 'undefined' &&
            typeof user.leader_id !== 'undefined' &&
            typeof user.pg_name !== 'undefined'
        );
    }

    public logOut() {
        delete localStorage.user;
        delete localStorage.data;

        this.eventBus.$emit('user-info', this.user = null);
    }

    public api(url?: string): string {
        return process.env.VUE_APP_API_ROOT + url;
    }

    public addZero(n: number): string {

        if (n < 10) {
            return '0' + n ;
        } else {
            return n.toString();
        }
    }

    public getMonth(n: number): string {
        const months = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ];

        return months[n - 1];
    }

    public isInvalidMonthYear(month: any, year: any, date: any): boolean {
        let error = false;

        date = date.trim();

        if (date !== '') {
            date = date.split('-').map(Number);

            error = (date[0] !== year || date[1] !== month);
        } else {
            error = true;
        }

        return error;
    }

    public persistData(data: any, type: any) {
        setTimeout(() => localStorage.data = JSON.stringify(data));
    }

    public getData() {
        try {
            return JSON.parse(localStorage.data);
        } catch (e) {
            return null;
        }
    }
}
export default new Utility();
